import type { OrderedListProps, UnorderedListProps } from 'react-markdown/lib/ast-to-react';
import { RichTextList, RichTextNumberedList } from './MarkdownComponents.styles';

export function UnorderedList({ children, depth }: UnorderedListProps) {
  let bulletType;

  if (depth === 0) {
    bulletType = 'disc';
  } else if (depth === 1) {
    bulletType = 'circle';
  } else {
    bulletType = 'square';
  }

  return <RichTextList $type={bulletType}>{children}</RichTextList>;
}

export function OrderedList({ children, depth }: OrderedListProps) {
  let listType;

  if (depth === 0) {
    listType = 'decimal';
  } else if (depth === 1) {
    listType = 'lower-alpha';
  } else {
    listType = 'lower-roman';
  }

  return <RichTextNumberedList $type={listType}>{children}</RichTextNumberedList>;
}
